import ClipboardJS from "clipboard";

import { Factory } from "@/data/dao/Factory";
import { VoucherDao } from "@/data/dao/service/VoucherDao";

import { logError } from "@/shared/logging/errors";

import { i18n } from "@/portal/Trans";
import { UiNotification } from "@/portal/ui/Notification";

export class VoucherCodeGenerator {
    private $element: JQuery;
    private dao?: VoucherDao;
    private voucherCode?: string;
    private entityId?: string;
    private clipboard?: ClipboardJS;

    constructor(element: JQuery) {
        this.$element = element;
    }

    public loadForVoucher(voucherId: string): VoucherCodeGenerator {
        this.dao = Factory.getInstance<VoucherDao>(VoucherDao);
        this.entityId = voucherId;

        this.load();
        return this;
    }

    private async load() {
        if (this.voucherCode !== undefined) {
            this.setExisting();
            return;
        }

        this.$element.html(
            '<div class="loading"><div class="kt-spinner kt-spinner--lg kt-spinner--success"></div> ' +
                i18n("general.loading") +
                "</div>"
        );

        try {
            const p = await this.dao!.getSingle(this.entityId!);
            this.voucherCode = p.code;
            if (this.voucherCode !== undefined) {
                this.setExisting();
            }
        } catch (ex) {
            logError(ex);
        }
    }

    private setExisting() {
        const link = this.voucherCode;

        const permalink = $('<div class="permalink"><div class="input-group"></div></div>')
            .appendTo(this.$element.empty())
            .find("> .input-group");
        const input = $('<input type="text" class="form-control" value="' + link + '" readonly />').appendTo(permalink);
        const btnGroup = $('<div class="input-group-append" />').appendTo(permalink);

        const clipBtn = $('<a href="#" class="btn btn-secondary copy"><i class="la la-copy"></i></a>')
            .appendTo(btnGroup)
            .click((e) => {
                e.preventDefault();
            });

        $('<a href="#" class="btn btn-secondary qr"><i class="la la-qrcode"></i></a>')
            .appendTo(btnGroup)
            .click((e) => {
                e.preventDefault();
                this.dao!.downloadQrCode(this.entityId!);
            });

        if (this.clipboard !== undefined) this.clipboard.destroy();

        this.clipboard = new ClipboardJS(clipBtn[0], {
            target: function () {
                return input[0];
            },
        });

        this.clipboard.on("success", (e) => {
            UiNotification.showSuccess(i18n("voucher.voucherCode.copiedClipboard"));
            e.clearSelection();
        });
    }
}
